import React, { useState, useRef } from "react";
import { Grid, Typography, Box, useMediaQuery, Tabs, Tab } from "@mui/material";
import PriceCard from "./PriceCard";
import MySvgIcons from '../Shared/paymentMethods';
import { useTheme } from "@mui/material/styles";

const h1Title = "Zamów Online";
const subtitle = "Zamów na wynos. Płać bezpiecznie online.";

function PricingSection({items}) {
  const isSmallScreen = useMediaQuery('(max-width:899px)');
  const [expandedItemId, setExpandedItemId] = useState(null);
  const [tabValue, setTabValue] = useState('Jedzenie');
  const theme = useTheme();
  const tabsRef = useRef(null);
  const swipeStartX = useRef(null);
  const swipeEndX = useRef(null);
  const swipeStartY = useRef(null);
  const swipeEndY = useRef(null);

  const handleCardExpand = (itemId) => {
    setExpandedItemId(prevId => (prevId === itemId ? null : itemId)); // Toggle expanded state
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);

    setTimeout(() => {
      if (tabsRef.current) {
        const rect = tabsRef.current.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.scrollY - 60,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  const handleTouchStart = (e) => {
    swipeStartX.current = e.touches[0].clientX;
    swipeStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    swipeEndX.current = e.changedTouches[0].clientX;
    swipeEndY.current = e.changedTouches[0].clientY;
    const swipeDistance = swipeStartX.current - swipeEndX.current;
    const swipeDistanceY = swipeStartY.current - swipeEndY.current;

    if (Math.abs(swipeDistanceY) < 100) {
      if (swipeDistance > 150) {
        // Swiped left
        setTabValue((prevValue) => {
          // if (prevValue === 'all') return 'Jedzenie';
          if (prevValue === 'Jedzenie') return 'Napoje';
          if (prevValue === 'Napoje') return 'Napoje Alkoholowe';
          return prevValue;
        });
      } else if (swipeDistance < -150) {
        // Swiped right
        setTabValue((prevValue) => {
          if (prevValue === 'Napoje Alkoholowe') return 'Napoje';
          if (prevValue === 'Napoje') return 'Jedzenie';
          // if (prevValue === 'Jedzenie') return 'all';
          return prevValue;
        });
      }
      if (swipeDistance > 150 || swipeDistance < -150) {
        setTimeout(() => {
          if (tabsRef.current) {
            const rect = tabsRef.current.getBoundingClientRect();
            window.scrollTo({
              top: rect.top + window.scrollY - 60,
              behavior: "smooth"
            });
          }
        }, 100);
      }
    }
  };

  const filterItems = () => {
    if (!items) return [];

    let filteredItems = items;
    if (tabValue !== 'all') {
      filteredItems = items.filter(item => item.itemType === tabValue.charAt(0).toUpperCase() + tabValue.slice(1));
    } else {
      const typeOrder = { 'Jedzenie': 1, 'Napoje': 2, 'Napoje Alkoholowe': 3 };
      filteredItems.sort((a, b) => typeOrder[a.itemType] - typeOrder[b.itemType]);
    }
    
    return filteredItems;
  };

  return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative',
      }}>

        <Grid container  sx={{
          width: "100%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          padding: "20px 0px",
        }}>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                width: isSmallScreen ? "100%" : "90%",
                margin: "0 auto",
                display: "flex",
                justifyContent: "center",
                padding: "0px 0px",
              }}
            >
              <Grid item xs={11} sm={11} md={11} lg={11} xl={9.1}>
                <Box sx={{ paddingBottom: '2rem' }}>
                <Typography variant="h1" gutterBottom>
                  {h1Title}
                </Typography>
                </Box>
              </Grid>

              <Grid item xs={11} sm={11} md={11} lg={11} xl={9.1}>
                <Typography variant="subtitle1" gutterBottom>
                  {subtitle}
                </Typography>
              </Grid>

              <Grid item xs={11} sm={11} md={11} lg={11} xl={9.1} sx={{paddingBottom: '1rem'}}>
                <MySvgIcons />
              </Grid>
              <Grid ref={tabsRef} container
                sx={{
                  width: isSmallScreen ? "100%" : "90%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "center",
                  padding: "20px 0px",
                }}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                <Tabs value={tabValue} onChange={handleChange} centered
                  sx={{
                    width: '98.5%',
                    position: 'sticky',
                    top: '64px',
                    zIndex: 1,
                    border: `1px solid ${theme.palette.component.borderColor}`,
                    backgroundColor: theme.palette.component.componentBackground,
                    boxShadow: `0 2px 4px ${theme.palette.component.borderColor}`,
                    marginBottom: '10px',
                  }}
                >
                  {/* <Tab label="All" value="all" /> */}
                  <Tab label="Jedzenie" value="Jedzenie" />
                  <Tab label="Napoje" value="Napoje" />
                  <Tab label="Napoje Alkoholowe" value="Napoje Alkoholowe" />
                </Tabs>
                {filterItems().map((item, index) => (
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3} key={index} sx={{padding: '0px 5px'}}>
                    <PriceCard
                      itemId={item._id}
                      itemName={item.itemName}
                      itemImage={item.itemImage}
                      itemType={item.itemType}
                      itemDetails={item.itemDetails}
                      itemIncludes={item.itemIncludes}
                      itemAvailable={item.itemAvailable}
                      expanded={expandedItemId === item._id}
                      onExpand={() => handleCardExpand(item._id)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
  );
}


export default PricingSection;